import {
  FaUserFriends,
  FaPalette,
  FaObjectUngroup
} from "react-icons/fa";

const uiuxData = {
  mainTitle: "Ganzheitliche UI/UX-Services – Ansprechende digitale Erlebnisse gestalten",
  mainDescription:
    "Unser nutzerzentrierter Designansatz stellt sicher, dass jedes Produkt intuitiv, visuell ansprechend und barrierefrei ist. Wir halten uns an branchenweite Best Practices und relevante Richtlinien wie WCAG und BSFG, um inklusive Erlebnisse zu schaffen, die Wachstum und Vertrauen fördern.",

  services: [
    {
      id: 1,
      icon: <FaUserFriends />,
      title: "Nutzerforschung & Persona-Entwicklung",
      description:
        "Wir beginnen damit, Ihre Nutzer zu verstehen – durch Interviews, Umfragen und Verhaltensanalysen – um detaillierte Personas zu erstellen, die Designentscheidungen und Unternehmensziele leiten.",
      features: [
        "Umfassende Nutzerinterviews",
        "Verhaltensdaten-Analyse",
        "Empathiekarten",
        "Persona- & Journey-Mapping",
      ],
    },
    {
      id: 2,
      icon: <FaPalette />,
      title: "Barrierefreies Design & Compliance",
      description:
        "Unsere Designs entsprechen anerkannten Barrierefreiheitsstandards wie WCAG 2.1 und BSFG, um allen Nutzern – einschließlich Menschen mit Behinderungen – ein inklusives Benutzererlebnis zu ermöglichen.",
      features: [
        "Einhaltung von WCAG 2.1",
        "Bildschirmleser- und Tastaturnavigation",
        "Kontrast- und Farbprüfungen",
        "Kontinuierliche Barrierefreiheitsprüfungen",
      ],
    },
    {
      id: 3,
      icon: <FaObjectUngroup />,
      title: "Prototyping & Usability-Tests",
      description:
        "Wir verwandeln Konzepte in interaktive Prototypen und validieren diese mit echten Nutzern. Dieser iterative Ansatz hilft, Funktionen zu optimieren, Risiken zu verringern und einen optimalen Nutzerfluss zu gewährleisten.",
      features: [
        "Low- & High-Fidelity-Prototypen",
        "A/B- und Nutzertests",
        "Iterative Designverbesserungen",
        "Detaillierte Usability-Berichte",
      ],
    },
  ],
};

export default uiuxData;
